
import React from "react";

function NuestraEsencia({ children }) {
    return (
        <section
            className="empresa-esencia"
            id="empresa-esencia"
        >
            <div className="empresa-section-label">
                <span>02</span>
                <span>NUESTRA ESENCIA</span>
            </div>

            <div className="empresa-esencia-grid">
                <div className="empresa-esencia-heading">
          <span className="empresa-eyebrow">
            NUESTRA FORMA DE VER EL MUNDO
          </span>

                    <h2>
                        Nuestra esencia
                        <br />
                        es clara:
                        <br />
                        <span>innovar para transformar.</span>
                    </h2>
                </div>

                <div className="empresa-esencia-copy">
                    <p className="empresa-lead">
                        Creemos en el talento, las ideas audaces y la
                        capacidad de la tecnología para generar cambios
                        significativos.
                    </p>

                    <p>
                        Con un equipo joven, talentoso y apasionado,
                        Vemasmas, bajo el liderazgo de Oscar Fredy
                        González Rivera, desarrolla soluciones que
                        responden a los retos más complejos de nuestro
                        entorno social, empresarial y gubernamental.
                    </p>

                    <p>
                        Lo que nos define es la audacia para ir más allá,
                        romper paradigmas y ofrecer propuestas tecnológicas
                        de alto impacto.
                    </p>
                </div>
            </div>

            {children}
        </section>
    );
}

export default NuestraEsencia;
